import { createI18n } from 'vue-i18n';
import { messages } from '@/composable/messages';

// i18nインスタンスを作成
const i18n = createI18n({
  legacy: false,
  locale: 'ja',
  messages,
});

export default i18n;
export const i18nGlobal = i18n.global;
